// @flow
import React, { PureComponent } from 'react';
import { StyleSheet } from 'react-native';
import { Button, Text } from 'trpc-react-native-ui';
import { withNavigation } from '@react-navigation/compat';
import type { NavigationScreenProp } from '@react-navigation/compat';
import { Icon } from '../../../components/common';
import I18n from '../../../lib/i18n';
import theme from '../../../theme-config';

class AddInternationalButton extends PureComponent<Props> {
  styles = getStyles();

  render() {
    const styles = this.styles;
    const iconSize = 20;

    return (
      <Button
        shadowEnabled={true}
        activeOpacity={0.7}
        disabled={this.props.disabled}
        onPress={this.props.goToInternational}
        style={styles.container}
      >
        <Icon name={'plus'} size={iconSize} style={styles.icon} />
        <Text style={styles.text}>{I18n.t('Dashboard.addInternational')}</Text>
      </Button>
    );
  }
}

type Props = NavigationScreenProp & {
  disabled?: boolean,
  goToInternational: Function,
};

const getStyles = () =>
   StyleSheet.create({
    container: {
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: theme.primaryColor,
      flexDirection: 'row',
      minHeight: 45,
      height: 55,
      borderRadius: 5,
    },
    icon: {
      color: theme.overPrimaryColor,
      marginHorizontal: 10,
    },
    text: {
      color: theme.overPrimaryColor,
      fontSize: 17,
      fontWeight: 'bold',
    },
  });

export default withNavigation(AddInternationalButton);
